export default "__VITE_ASSET__D1vfbD5H__";